export default __webpack_public_path__ + "static/media/thumbs-down.d6c0e46c.svg";